<template>
  <div class="audio-player" unselectable="on">
    <div class="c-default-img audio-player__thumb">
      <img v-if="img" :src="img" alt />
    </div>
    <div class="audio-player__main">
      <div class="audio-player__title">{{title}}</div>
      <gxxt-slider :disabled="true" class="w420" v-model="sliderValue"></gxxt-slider>
      <div class="audio-player__times">
        <span class="current-time">{{currentTime}}</span>
        <span class="total-time">{{total}}</span>
      </div>
    </div>
    <div class="audio-player__play-button" @click="handlePlay">
      <img v-if="playing" src="~@/assets/images/player/smallpause.png" />
      <img v-else class="playing" src="~@/assets/images/player/smallplay.png" />
    </div>
  </div>
</template>

<script>
import { GxxtSlider } from '@/components'
import { secondsFormat } from '@/utils/common'
export default {
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    mediaReadPercent: {
      type: [Number, String],
      default: 0,
    },
    playing: {
      type: Boolean,
      default: false,
    },
    timeLong: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    player: {
      type: Object,
      default: null,
    },
  },
  emits: ['change', 'handlePlay'],
  watch: {
    sliderValue(v) {
      this.$emit('change', v)
    },
    // mediaReadPercent(v) {
    //   console.log(v)
    //   this.currentTime = v
    // },
    player(v) {
      if (v != null) {
        // 上次看到
        this.sliderValue = (this.mediaReadPercent / this.timeLong) * 100
        this.currentTime = secondsFormat(this.mediaReadPercent)
        v.on('ready', (e) => {
          // 跳转到上次播放位置
          v.seek(this.mediaReadPercent)
          // 监听播放位置改变
          v.on('timeupdate', () => {
            let cur = v.getCurrentTime()
            this.sliderValue = (cur / this.timeLong) * 100
            this.currentTime = secondsFormat(cur)
          })
          // 播放停止后更新播放按钮的状态
          v.on('ended', () => {
            this.$emit('handlePlay', false)
          })
        })
      }
    },
  },
  computed: {
    total() {
      return secondsFormat(this.timeLong)
    },
  },
  data() {
    return {
      sliderValue: 0,
      currentTime: '00:00',
    }
  },
  methods: {
    handlePlay() {
      this.$emit('handlePlay', !this.playing)
    },
  },
  components: {
    GxxtSlider,
  },
}
</script>

<style lang="less" scoped>
* {
-webkit-touch-callout:none;
-webkit-user-select:none;
-khtml-user-select:none;
-moz-user-select:none;
-ms-user-select:none;
user-select:none;
}
.audio-player {
  user-select: none;
  display: flex;
  width: 686px;
  height: 140px;
  background: #f7f7f7;
  border-radius: 10px;
  position: relative;
  padding-right: 20px;
  justify-content: space-between;
  overflow: hidden;
}
.audio-player__title {
  width: 432px;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  padding: 22px 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
}
.w420 {
  width: 420px;
}
.audio-player__thumb {
  flex: 106px 0 0;
  height: 140px;
  img {
    width: 100%;
    height: 100%;
  }
}
.audio-player__play-button {
  flex: 80px 0 0;
  height: 80px;
  background: #ff5500;
  margin-top: 30px;
  position: relative;
  border-radius: 50%;
  img {
    width: 34px;
    height: 34px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .playing {
    margin-left: 2px;
  }
}
.audio-player__times {
  width: 420px;
  margin-top: -2px;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 1;
  display: flex;
  justify-content: space-between;
}
</style>